import ObservableRaceStarter from '@classic/Betting-v2/Model/Observables/ObservableRaceStarter'
import { BettingInformation } from '@classic/Betting-v2/Model/BettingInformation'
import ObservableRaceKey from '@classic/Betting-v2/Model/Observables/ObservableRaceKey'
import { MatchedFieldSummary } from '@core/Areas/Racing/Components/FieldSummary/MatchedFieldSummary'
import { JockeyName } from '@core/Areas/RaceCard/Components/JockeyName'
import BaseStarterViewModel from './../BaseStarterViewModel'

export interface Params {
  data: ObservableRaceStarter
  raceNumber: ObservableRaceKey
  context: { bettingContext: BettingInformation }
  numberOfStartersInRace: ko.Computed<number>
  doubleProvDivAllowed: ko.Observable<boolean>
  quaddieProvDivAllowed: ko.Observable<boolean>
  isRaceClosed: ko.Observable<boolean>
}

export class RaceStarterViewModel extends BaseStarterViewModel {
  public MatchedFieldSummary = MatchedFieldSummary
  public JockeyName = JockeyName

  constructor(params: Params) {
    super(
      params.data,
      params.raceNumber,
      params.context.bettingContext,
      'Races',
      params.numberOfStartersInRace,
      params.doubleProvDivAllowed,
      params.quaddieProvDivAllowed,
      params.isRaceClosed
    )
  }
}
